<mat-chip-set aria-label="User Information">
  <mat-chip *ngIf="patient.caseName"
            color="warn"
            [ngClass]="['mat-body', 'case-name']">
    <b>
      Patient ID:
    </b>
    &nbsp;
    <b style="color: black;">
      {{patient.caseName}}
    </b>
  </mat-chip>
  <mat-chip *ngIf="patient.LegalCaseId"
            disableRipple="true"
            [ngClass]="'mat-body'">
    {{Labels.clientMatterLabel}} ID - {{ patient.LegalCaseId }}
  </mat-chip>
  <mat-chip *ngIf="patient.DateOfBirth"
            color="warn"
            disableRipple="true"
            [ngClass]="'mat-body'">
    DOB - {{ patient.DateOfBirth }}
  </mat-chip>

  <mat-chip *ngIf="patient.clientUser && patient.clientUser.length > 0 && !['silver', 'gold'].includes(plancode)"
            color="warn">
    <b>
      patient user:
    </b>
    &nbsp;
    <a href="mailto:{{ patient.clientUser }}"
       style="color:rgb(168, 0, 0)">
      {{patient.clientUser}}
    </a>
  </mat-chip>
</mat-chip-set>
